module.exports = __webpack_public_path__ + "static/img/mark_blue_small.2515cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mark_blue_small.png
// module id = 8LyD
// module chunks = 1